<template>
  <div class="page-content">
    <el-row class="operators">
      <el-col>
        <el-button type="primary" class="first-btn" @click="addHandle">新增</el-button>
      </el-col>
    </el-row>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" style="width: 100%">
        <el-table-column prop="vendorId" label="厂商Id" align="center">
        </el-table-column>
        <el-table-column prop="vendorModelName" label="型号名称" align="center">
        </el-table-column>
        <el-table-column prop="vendorModelId" label="型号Id" align="center">
        </el-table-column>
        <el-table-column prop="vendorModelDesc" label="型号描述" align="center">
        </el-table-column>
        
        <el-table-column prop="operation" label="操作" align="center" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="addHandle(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增用户dialog -->
    <addDialog v-if="addDialogVisible" :addDialogVisible="addDialogVisible" :modelUpdateId="modelUpdateId" @closeAddDialog="closeAddDialog" />
  </div>
</template>

<script>
import addDialog from '@/components/modelDialog/addDialog'
import { modelList, modelDelete } from '@/api/productControl'
export default {
  data() {
    return {
      tableData: [],
      addDialogVisible: false,
      modelUpdateId: ''
    }
  },
  components: {
    addDialog,
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const params = {}
      modelList(params).then(res => {
        this.tableData = res.data.data.list
      })
    },
    addHandle(row) {
      if (row) {
        this.modelUpdateId = row.id;
      }
      this.addDialogVisible = true;
    },
    closeAddDialog(val) {
      this.addDialogVisible = false
      if (val) {
        this.getList()
      }
    },
    closeEditDialog(val) {
      this.editDialogVisible = false
      if (val) {
        this.getList()
      }
    },
    handleDelete(row) {
      this.$confirm('正在删除当前厂商模型, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'error'
      }).then(() => {
        const params = {
          id: row.id
        }
        modelDelete(params).then((res) => {
          if (res.data.code === 200 || res.data.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '删除取消'
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
  .operators {
    margin-bottom: 10px;
  }
</style>
